import React, { useState, useEffect } from "react";
import "../styles/RecommendSongModal.css";
import { recommendMusic } from "../services/RecommendMusicService";

interface RecommendSongModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RecommendSongModal = ({
  isOpen,
  onClose,
}: RecommendSongModalProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const [formData, setFormData] = useState({
    songLink: "",
    instagram: "",
    comment: "",
  });

  useEffect(() => {
    if (!isOpen) {
      setShowSuccess(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await recommendMusic(formData);

      setFormData({
        songLink: "",
        instagram: "",
        comment: "",
      });

      setShowSuccess(true);
    } catch (error) {
      alert("Error sending recommendation. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content recommend-song-modal"
        onClick={(e) => e.stopPropagation()}
      >
        {showSuccess ? (
          <div className="success-view">
            <div className="success-header">
              <span className="success-subtitle">Recommendation Received</span>
            </div>

            <div className="success-content">
              <h3 className="success-heading">
                Thanks for the Recommendation!
              </h3>
              <p>
                We appreciate you taking the time to put us on to what you're
                playing.
              </p>
              <p>
                Interested in joining our curation team? Reach out via our
                contact form.
              </p>
              <button
                type="button"
                className="submit-btn success-btn"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        ) : (
          <>
            <div className="modal-header-section">
              <h2 className="modal-title">Recommend a Song</h2>
              <p className="modal-subtitle">Put us on to what you're playing</p>
            </div>

            <form onSubmit={handleSubmit} className="recommend-form">
              <div className="form-group">
                <label htmlFor="songLink">Song Link</label>
                <input
                  type="url"
                  id="songLink"
                  name="songLink"
                  placeholder="Spotify, AppleMusic, etc"
                  value={formData.songLink}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                />
              </div>

              <div className="form-group">
                <label htmlFor="instagram">Instagram (Optional)</label>
                <input
                  type="text"
                  id="instagram"
                  name="instagram"
                  placeholder="Instagram @"
                  value={formData.instagram}
                  onChange={handleChange}
                  disabled={isSubmitting}
                />
              </div>

              <div className="form-group">
                <label htmlFor="comment">Comment (Optional)</label>
                <textarea
                  id="comment"
                  name="comment"
                  placeholder="Why do you like this track? Why do you like the artist?"
                  value={formData.comment}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  rows={4}
                />
              </div>

              <div className="form-actions">
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={onClose}
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Sending..." : "Recommend"}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};
